<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <wt-form-table :form.sync="form" >
        <wt-form-table-list slot="wtFormTableList" :form.sync="form">
          <template slot="garbageWeight" slot-scope="data">
            <span>{{ $wtUtil.transWeight(data.row.garbageWeight) }}</span>
          </template>
          <template slot="garbagePrice" slot-scope="data">
            <span>{{ $wtUtil.transMoney(data.row.garbagePrice) }}</span>
          </template>
          <template slot="garbageTotalPrice" slot-scope="data">
            <span>{{ $wtUtil.transMoney(data.row.garbageTotalPrice) }}</span>
          </template>
        </wt-form-table-list>
      </wt-form-table>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CustomerPayIncome',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      detailFormButtons: {
        title: '收入明细',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      form: { //  表单数据
        isFormLoading: false,
        formComponent: {
          list: { type: 'default', value: '/modules/userWechat/userCustomerIncomeList' }
        },
        formInputsData: [{ name: '搜索垃圾', key: 'garbageName', value: '', type: 'text' },
          { name: '交付时间', key: 'updateTimeRange', value: [], type: 'datetime' },
          { name: '用户', key: 'userId', value: 0, type: 'customAll' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXCEL',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/userWechat/userCustomerIncomeListImport',
          fileName: '大客户支付收入明细' }],
        formTableData: [
          { name: '垃圾', key: 'garbageName', type: 'text' },
          { name: '重量（kg）', key: 'garbageWeight', type: 'custom' },
          { name: '单价（元）', key: 'garbagePrice', type: 'custom' },
          { name: '交付时间', key: 'createTime', type: 'text', sortable: 'custom' },
          { name: '价值', key: 'garbageTotalPrice', type: 'custom' },
          { name: '操作人员', key: 'employeesUserName', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true }
      }
    }
  },
  created() {
    this.$store.dispatch('appendBreadcrumb', { meta: { title: '收入明细' }})
    this.form.formInputsData[2].value = this.customerId
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
      }
    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      customerId: state => state.userWechat.customerId
    })
  }
}
</script>
